/**
 * @generated SignedSource<<601963b15692064ea998e87ce3942734>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_Header_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"src_issueTableHideDoneToggle_HideDoneItemsToggle_project">;
  readonly " $fragmentType": "main_issueNavigator_Header_project";
};
export type main_issueNavigator_Header_project$key = {
  readonly " $data"?: main_issueNavigator_Header_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_Header_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "main_issueNavigator_Header_project",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "src_issueTableHideDoneToggle_HideDoneItemsToggle_project"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "3f3051226cf8fdc0cad41f59ebef9557";

export default node;
